import script from "./ConfirmEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmEmail.vue?vue&type=style&index=0&id=6203a4b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6203a4b8"]])

export default __exports__